import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GlobalNavCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GlobalNavCurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, username: string, firstName?: string | null, lastName?: string | null } | null };


export const GlobalNavCurrentUserDocument = gql`
    query GlobalNavCurrentUser {
  currentUser {
    id
    username
    firstName
    lastName
  }
}
    `;

/**
 * __useGlobalNavCurrentUserQuery__
 *
 * To run a query within a React component, call `useGlobalNavCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalNavCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalNavCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalNavCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>(GlobalNavCurrentUserDocument, options);
      }
export function useGlobalNavCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>(GlobalNavCurrentUserDocument, options);
        }
// @ts-ignore
export function useGlobalNavCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>;
export function useGlobalNavCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GlobalNavCurrentUserQuery | undefined, GlobalNavCurrentUserQueryVariables>;
export function useGlobalNavCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>(GlobalNavCurrentUserDocument, options);
        }
export type GlobalNavCurrentUserQueryHookResult = ReturnType<typeof useGlobalNavCurrentUserQuery>;
export type GlobalNavCurrentUserLazyQueryHookResult = ReturnType<typeof useGlobalNavCurrentUserLazyQuery>;
export type GlobalNavCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGlobalNavCurrentUserSuspenseQuery>;
export type GlobalNavCurrentUserQueryResult = Apollo.QueryResult<GlobalNavCurrentUserQuery, GlobalNavCurrentUserQueryVariables>;